// extracted by mini-css-extract-plugin
export default {"web5-device-login-connect":"Ur8iNG","web5DeviceLoginConnect":"Ur8iNG","connect-button":"r4Xg6d","connectButton":"r4Xg6d","codeInput":"Y1Jbw1"};